<template>
	<Window
		ref="privacyTips"
		:btnCancel="false"
		:title="''"
		:btnClose="false"
		:size="'xs'"
		:btnMode="'upDown'"
	>
		<div>
			<div class="taC fs14x">{{$t('all26',[$t(`${businessCode}`),'欢迎使用小麦商家版'])}}</div>
			<div
				class="mt2x mb1x"
			>{{$t('all27',[$t(`${businessCode}`),'我们非常重视您的隐私保护和个人信息保护，我们特别提示您在使用小麦商家版服务前，阅读服务协议及隐私协议，以了解我们在收集和使用您的相关个人信息时的处理规则。'])}}</div>
			<div>
				{{getLanguageStr("all28","请您仔细阅读并确认")}}
				<a
					:href="stage.setting.loc.privacyStatementUrl[stage.languageId]"
					target="_blank"
					class="cPrimary"
				>{{getLanguageStr("user96","《服务协议》")}}</a>
				<template v-if="stage.setting.loc.privacyPolicyUrl">
					{{getLanguageStr("all29","和")}}
					<a
						:href="stage.setting.loc.privacyPolicyUrl[stage.languageId]"
						target="_blank"
						class="cPrimary"
					>{{getLanguageStr("all30","《隐私协议》")}}</a>
				</template>
				{{getLanguageStr("all31","。若选择不同意，将无法使用我们的产品和服务。")}}
			</div>
		</div>
		<button
			class="functionBtn tra-fast"
			@click.stop="hide()"
			:title="$t('all32',['同意并进入'])"
			type="button"
			slot="btmBtnUD"
			style="padding:1em 0;margin:3em 2em 2em;"
		>{{$t('all32',['同意并进入'])}}</button>
		<button slot="btmBtnUD" @click="refuse">{{getLanguageStr("all33","不同意")}}</button>
		<div class="cb"></div>
	</Window>
</template>
<script>
// import {mapGetters} from 'vuex';
import * as authUtils from '@/util/auth';
import * as lib from '@/util/lib';
import {getLanguageStr} from '@/util/language';
import Window from '@/components/common/ui/WindowForAlert';
import Checkbox from '@/components/common/ui/Checkbox.vue';
import {setPrivacyPolicyYes, getPrivacyPolicy} from '@/api/login';
export default {
	name: 'privacyTips',
	props: {
		title: {
			// 设置弹窗的标题
			type: String,
			default: ''
		}
	},
	components: {
		Window,
		Checkbox
	},
	data () {
		return {
			stage,
			businessCode: stage.loc.customerDisplay[stage.languageId] || stage.loc.customerDisplay.public
		};
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		getYES () {
			return new Promise(async (resolve, reject) => {
				var token = authUtils.getToken();
				if (!stage.setting.loc.privacyPolicyUrl.public) {
					resolve(true);// 没有隐私协议
				} else if (lib.getCookie('firstPrivacy')) {
					resolve(true);// 本客户端已经同意过
				} else if (token) {
					let req = {
						system: stage.loc.customer,
						clientType: 'Web',
						businessType: stage.loc.platformCode
					};
					await getPrivacyPolicy(req).then(
						res => {
							if (res) {
								window.readPrivacy = true;
								resolve(true);
							} else {
								window.readPrivacy = false;
								this.show();
								reject(false);
							}
						},
						error => {
							!_.isEmpty(error) && this.$notify(error);
						}
					);
				} else {
					this.show();
					reject(false);
				}
			});
		},
		show () {
			this.$refs.privacyTips.show();
		},
		refuse () {
			this.$toast(
				getLanguageStr(
					'all34',
					'抱歉，您需要同意《服务协议》与《隐私协议》后才能使用本软件'
				)
			);
			//	this.$Message.info('This is a info tip');
			// this.$notify(getLanguageStr('all34', '抱歉，您需要同意《服务协议》与《隐私协议》后才能使用本软件'))
			return false;
		},
		setFirst () {
			lib.setCookie('firstPrivacy', true);
			this.$refs.privacyTips.hide();
			return true;
		},
		setYes () {
			lib.setCookie('firstPrivacy', true);
			var token = authUtils.getToken();
			if (token) {
				const data = {
					businessType: stage.loc.platformCode,
					clientType: 'Web',
					readStatus: 1,
					system: stage.loc.customer
				};
				setPrivacyPolicyYes(data).then(
					res => {
						if (this.$route.path == '/login') {
							this.$emit('loginAgain');
						}
						this.$refs.privacyTips.hide();
						return res;
					},
					error => {
						!_.isEmpty(error) && this.$notify(error);
					}
				);
			}
			this.$emit('check', true);
		},
		hide () {
			this.setYes();
			this.$refs.privacyTips.hide();
			return true;
			//	 if (lib.getCookie("privacyAgreementPrompt")) {
			//		 this.setYes();
			//	 } else {

			//	 }
		}
	}
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/frame/PrivacyTips.vue